import React from 'react'
import { ReportTabs } from '../helpers/reportTabs'
import KpiCardsSection from '../components/KpiCardsSection'

export default function ReportTabMobileKpiSection({
  selectedTab,
  kpiFlat,
  isSingleDayRange = true
}) {
  if (selectedTab === ReportTabs.summary) {
    return null
  }

  return (
    <KpiCardsSection
      kpiData={kpiFlat}
      selectedTab={selectedTab}
      collapsibleSections
      compactValues
      isSingleDayRange={isSingleDayRange}
    />
  )
}
